import axios from 'axios'
import { MessageBox, Message, Loading } from 'element-ui'
import store from '@/store'
import { getToken, removeToken, removeUserInfo } from '@/utils/auth.js'
// import vueInstance from '@/main'
// create an axios instance
var host
if (process.env.NODE_ENV === 'development') {
  // 开发环境
  host = 'http://192.168.1.168:8086/'
} else {
  host = 'http://education.alchiguru.com/platformapi/'
}
const service = axios.create({

  baseURL: host,
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})
let loadingInstance; // 定义loading变量
// request interceptor
service.interceptors.request.use(
  config => {
    // if (getToken()) {
    //   config.headers['token'] = getToken()
    // }

    // 显示loading
    if (!loadingInstance) {
      loadingInstance = Loading.service({
        fullscreen: true,
        text: '加载中...'
      });
    }
    if (getToken()) {
      config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    if (config.method === 'post') {
      if (typeof (config.data) == 'object')
        config.headers['Content-Type'] = 'application/json'
      config.data = JSON.stringify(config.data)
    }
    return config
  },
  error => {
    if (loadingInstance) {
      loadingInstance.close();
    }
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    // 关闭loading
    if (loadingInstance) {
      loadingInstance.close();
      loadingInstance = null;
    }
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 200) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      if (res.code === 401) { // token 过期
        removeToken()
        location.href = '/login';
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    if (loadingInstance) {
      loadingInstance.close();
    }
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
